<template>
  <div class="h-full" :class="{'overflow-y-hidden': !scrollable}">
    <router-view />
    <LoaderModal/>
    <FileModal/>
    <BlobFileModal/>
    <BlobModal/>
    <PdfFileModal/>
    <vue-snotify />
  </div>
</template>
<script>
export default {
  data() {
    return {
      scrollable: true
    }
  },
  beforeMount() {
    this.$emitter.on('body-unscrollable', () => {
      this.scrollable = false
    })
    this.$emitter.on('body-scrollable', () => {
      this.scrollable = true
    })
  },
  beforeUnmount() {
    this.$emitter.off('body-unscrollable')
    this.$emitter.off('body-scrollable')
  }
}
</script>